import { useState, useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { errText } from "@/lib/api";

export default function BASettings() {
  const qc = useQueryClient();
  const [form, setForm] = useState({ business_name: "", opening_balance: "" });

  const { data } = useQuery({ queryKey: ["ba-settings"], queryFn: async () => (await api.get("/ba/settings")).data });

  useEffect(() => {
    if (data) setForm({ business_name: data.business_name || "", opening_balance: data.opening_balance ?? "" });
  }, [data]);

  const save = useMutation({
    mutationFn: async () => (await api.put("/ba/settings", { ...form, opening_balance: Number(form.opening_balance) || 0 })).data,
    onSuccess: () => {
      toast.success("Settings saved");
      qc.invalidateQueries({ queryKey: ["ba-settings"] });
      qc.invalidateQueries({ queryKey: ["ba-dashboard"] });
    },
    onError: (e) => toast.error(errText(e)),
  });

  return (
    <div className="max-w-md space-y-5" data-testid="ba-settings-page">
      <h2 className="font-heading text-xl font-semibold tracking-tight">Settings</h2>
      <div className="rounded-xl border bg-card p-6 space-y-4">
        <div className="space-y-2">
          <Label className="text-xs uppercase tracking-widest text-muted-foreground">Business Name</Label>
          <Input data-testid="ba-business-name-input" value={form.business_name} onChange={(e) => setForm({ ...form, business_name: e.target.value })} />
        </div>
        <div className="space-y-2">
          <Label className="text-xs uppercase tracking-widest text-muted-foreground">Opening Cash Balance ₹</Label>
          <Input data-testid="ba-opening-balance-input" type="number" value={form.opening_balance} onChange={(e) => setForm({ ...form, opening_balance: e.target.value })} />
          <p className="text-xs text-muted-foreground">Added to the Current Cash Balance calculation.</p>
        </div>
        <Button data-testid="ba-settings-save-button" className="w-full rounded-lg" disabled={save.isPending} onClick={() => save.mutate()}>
          Save Settings
        </Button>
      </div>
    </div>
  );
}
